var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyteDiscoveryListing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "black",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7089 8.92403C22.7089 8.0222 21.9778 7.29113 21.076 7.29113L18.038 7.29113L18.038 6L21.076 6C22.6909 6 24 7.30913 24 8.92403L24 11.962L22.7089 11.962L22.7089 8.92403Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29114 8.92403C7.29114 8.0222 8.02222 7.29113 8.92405 7.29113L11.962 7.29113L11.962 6L8.92405 6C7.30914 6 6 7.30913 6 8.92403L6 11.962L7.29114 11.962L7.29114 8.92403Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.076 22.7089C21.9778 22.7089 22.7089 21.9778 22.7089 21.076L22.7089 18.038L24 18.038L24 21.076C24 22.6909 22.6909 24 21.076 24L18.038 24L18.038 22.7089L21.076 22.7089Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29114 21.076C7.29114 21.9778 8.02222 22.7089 8.92405 22.7089L11.962 22.7089L11.962 24L8.92405 24C7.30914 24 6 22.6909 6 21.076L6 18.038L7.29114 18.038L7.29114 21.076Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8607 14.2406C16.8607 15.6247 15.7386 16.7469 14.3544 16.7469C12.9702 16.7469 11.8481 15.6247 11.8481 14.2406C11.8481 12.8564 12.9702 11.7342 14.3544 11.7342C15.7386 11.7342 16.8607 12.8564 16.8607 14.2406ZM16.5443 17.3434C15.9255 17.7809 15.17 18.038 14.3544 18.038C12.2571 18.038 10.5569 16.3378 10.5569 14.2406C10.5569 12.1433 12.2571 10.4431 14.3544 10.4431C16.4517 10.4431 18.1519 12.1433 18.1519 14.2406C18.1519 15.0561 17.8948 15.8116 17.4573 16.4304L20.1273 19.1005L19.2144 20.0134L16.5443 17.3434Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyteDiscoveryListing);
export default __webpack_public_path__ + "static/media/syte-discovery-listing.b97c7780.svg";
export { ForwardRef as ReactComponent };